<!-- Simpler component API, only meant for non-interactive plain text -->

<template>
  <Root :disabled="disabled || !text">
    <Trigger v-bind="$attrs" :ref="forwardRef">
      <slot></slot>
    </Trigger>

    <Content v-if="text" :size="size">
      {{ text }}
    </Content>
  </Root>
</template>

<script setup lang="ts">
import { useForwardExpose } from "reka-ui";

import Content from "./Content.vue";
import Root from "./Root.vue";
import Trigger from "./Trigger.vue";

defineOptions({
  inheritAttrs: false,
});

defineProps<{
  text?: string;
  disabled?: boolean;
  size?: "xs";
}>();

const { forwardRef } = useForwardExpose();
</script>
